import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IApiError, IMessageResponse, ISendMessageData } from '../model/messageMutation';

const helperAiMessageFn = (data: ISendMessageData) => apiClient.post(`${APP_API_AI_ASSISTANT}message`, data);

export const useHelperAiMessageMutation = () =>
  useMutation<IMessageResponse, AxiosError<IApiError>, ISendMessageData>({
    mutationFn: helperAiMessageFn,
  });
